import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import { OrbitaxConnectTileViewerComponent } from './components/orbitax-connect-tile-viewer/orbitax-connect-tile-viewer.component';
import { OrbitaxConnectStepByStepChecklistComponent } from './components/orbitax-connect-step-by-step-checklist/orbitax-connect-step-by-step-checklist.component';
import { OrbitaxConnectDialogDefinitionFormViewComponentComponent } from './components/orbitax-connect-dialog-definition-form-view-component/orbitax-connect-dialog-definition-form-view-component.component';


export class OrbitaxConnectDynamicComponentHelper {
  static components: any;

  static create (): void {
  }

  public static init () {
    if (OrbitaxConnectDynamicComponentHelper.components) {
      return;
    }
    const components = {};
     components['OrbitaxConnectTileViewerComponent'] = OrbitaxConnectTileViewerComponent;
     components['OrbitaxConnectStepByStepChecklistComponent'] = OrbitaxConnectStepByStepChecklistComponent;
      components['OrbitaxConnectDialogDefinitionFormViewComponentComponent'] = OrbitaxConnectDialogDefinitionFormViewComponentComponent;
    OrbitaxConnectDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }
  public static register(key: string, component: any) {
    OrbitaxConnectDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }
  public static getComponentArray (): any[] {
    OrbitaxConnectDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(OrbitaxConnectDynamicComponentHelper.components).forEach(key => {
      componentArray.push(OrbitaxConnectDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }
}
